import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import { connect } from 'react-redux';
import '../style';


class SimpleSnackbar extends React.Component {
  state = {
    open: false,
    message: ''
  };

  handleClick = () => {
    this.setState({ open: true });
  };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({ open: false });
  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.ErrorMessage && nextProps.ErrorMessage !== this.props.ErrorMessage) {
      this.setState({ open: true, message: nextProps.ErrorMessage.message })
    } else if (nextProps.SuccessMessage && nextProps.SuccessMessage !== this.props.SuccessMessage) {
      this.setState({ open: true, message: nextProps.SuccessMessage.message })
    }
  }

  render() {
    const { open, message } = this.state

    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          open={open}
          autoHideDuration={5000}
          onClose={this.handleClose}
          variant="error"
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          classes={{}}
          message={<span id="message-id">{message}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    SuccessMessage: state.globalserverMessage.SuccessMessage,
  };
}

export default connect(mapStateToProps, {})(SimpleSnackbar);



// WEBPACK FOOTER //
// ./src/components/SimpleSnackbar.js